<div
  class="sg-checkbox sg-checkbox--{{ size }} sg-checkbox--{{ type }}"
  [class.sg-checkbox--checked]="checked"
  [class.sg-checkbox--disabled]="disabled"
  role="checkbox"
  tabindex="0"
  [attr.aria-checked]="checked"
  [attr.aria-disabled]="disabled"
  [attr.aria-label]="ariaLabel"
  (click)="onToggle()"
  (keydown)="onKeydown($event)"
  (blur)="onBlur()"
>
  <div class="sg-checkbox__box">
    <ptl-icon class="sg-checkbox__icon" [icon]="LucideCheck" [size]="iconSize"></ptl-icon>
  </div>
  <ng-content></ng-content>
</div>
